import { Grid, Text } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import { Form_RichText } from '../../../../../../../react-commons/components/form/inputs/Form_RichText';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ToolPropertyValidation,
    type ToolResource,
} from '../../../../../resource/resources/artifacts/tool/toolResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const ToolContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<ToolResource>;
    formNames: FormNames<ToolResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: ToolPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.TOOL,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={12}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(ToolPropertyValidation.NAME)}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={12}>
                <Text>Description</Text>
                <Form_RichText name={formNames.description} form={form} readonly={readOnly} />
            </Grid.Col>
        </Grid>
    );
};
